module.exports = __webpack_public_path__ + "assets/img/classify.75d3a32c.png";